<div class="flxClmn" style="height: calc(100vh - 50px);">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Incidents and Activity</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Investigate user activity and incidents that may indicate account takeover</span>
		</div>
	</div>
	<div class="page-inner-content-holder flxClmn no-scroll">
		<div class="flxRow hSpace1" style="margin-bottom: 15px; z-index: 50;">
			<btn-c variant="{{selectedViewType === viewTypes.timeline ? '' : 'outlined'}}"
				 [isDisabled]="loadingIncidentsInProcess"
				 (action)="changeViewType(viewTypes.timeline)">
				Show Timeline
			</btn-c>
			<btn-c variant="{{selectedViewType === viewTypes.list ? '' : 'outlined'}}"
				 [isDisabled]="loadingIncidentsInProcess"
				 (action)="changeViewType(viewTypes.list)">
				Show List
			</btn-c>
			<div class="vertical-separator" style="align-self: stretch; margin: 0 20px; border-color: lightgrey;"
				 *ngIf="selectedViewType === viewTypes.timeline"></div>
			<app-dropdown-c style="width: 300px;"
						  *ngIf="selectedViewType === viewTypes.timeline"
						  [text]="selectedUserForTimeline?.displayName"
						  [enableSearch]="true"
						  itemDisplayKey="displayName"
						  [items]="usersInIncidentsList"
						  (onItemClicked)="prepareIncidentsTimeLine($event.item)"></app-dropdown-c>
		</div>

		<!--VIEW: list-->
		<div class="flxClmn f-1-0 animated fadeIn" style="overflow: auto;" *ngIf="selectedViewType === viewTypes.list">
			<!--incidents table-->
			<trustifi-table-c
					class="trustifi-table" style="flex: 1 0; z-index: 5; --table-filter-min-width: 500px;"
					[list]="incidents"
					[headers]="[
						{text:'Created', sortKey:'created', width: '15%'},
						{text:'User Name', sortKey:'user_name'},
						{text:'Status', sortKey:'status', width: '15%'},
						{text:'Type', sortKey:'incident_type'},
					]"
					[cellsPrototype]="[
						{textKey: 'created', textType: 'dateAndTime'},
						{html: 'userNameCell'},
						{html: 'incidentStatusCell'},
						{html: 'incidentTypeCell'},
					]"
					[bulkActions]="{
						enable: true,
						selectBulkActionCb:	selectMultipleIncidentsAction,
						initBulkActionsFunction: showIncidentBulkActions
					}"
					[cellActions]="{
						enable: true,
						selectItemActionCb:	selectAction,
						initActionsFunction: showIncidentsActions
					}"

					(searchFunction)="searchIncident($event.searchTerm, $event.activeFilters)"
					[filterData]="filterData"
					[options]="{
					exportToCsvFunction: exportToCsv,
					loadingTableFlag: loadingIncidentsInProcess,
					itemsNameSingular: 'incident',
					refreshFunction: getIncidents,
					defaultSortKey: '-created'
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--User name cells-->
					<span *ngIf="cellId === 'userNameCell'" title="{{item.user_name}}">{{item.user_name}} ({{item.user_email}})</span>
					<!--Type cells-->
					<span *ngIf="cellId === 'incidentTypeCell'" style="color: darkred;">{{dic.CONSTANTS.accountCompromisedIncidentTypes[item.incident_type].name}}</span>
					<!--status cells-->
					<span *ngIf="cellId === 'incidentStatusCell'" [ngStyle]="{'color': item.status.toLowerCase() === dic.CONSTANTS.compromisedIncidentStatus.approved ? 'darkgreen' : item.status.toLowerCase() === dic.CONSTANTS.compromisedIncidentStatus.compromised ? 'darkred' : 'darkorange',}">
						<span style="text-transform: capitalize;">{{item.status}}</span>
						<span *ngIf="item.approved_by" style="flex: 1 0;" title="{{item.approved_by}}">
							({{item.approved_by}})
						</span>
					</span>
				</ng-template>
			</trustifi-table-c>
		</div>

		<!--VIEW: timeline-->
		<div class="flxRow gap-4 f-1-0 animated fadeIn bs-enabled" #timelineContainer style="overflow: auto; background: #fbfbfb;" *ngIf="selectedViewType === viewTypes.timeline">
			<div class="d-flex centralize f-1-0" style="flex-grow:1; display: flex; background: white;" *ngIf="loadingIncidentsInProcess">
				<loader height="100" width="100" style="opacity: 0.8;"></loader>
			</div>

			<div class="flex-column" style="flex: 3 0; padding: calc((20px + 3vw)/2) calc((15px + 4vw)/2);" *ngIf="!loadingIncidentsInProcess">
				<virtual-scroller class="f-1-0" #scroll *ngIf="flatIncidentsByDate?.length" [items]="flatIncidentsByDate" [scrollAnimationTime]="0"  [parentScroll]="timelineContainer" [enableUnequalChildrenSizes]="true">
					<ng-container *ngFor="let incident of scroll.viewPortItems; trackBy: gs.trackByIndex">
						<!--Date label-->
						<div style="margin: 15px 0 10px 27px;" *ngIf="incident.type === 'date'">
							<span style="background: white; padding: 5px 15px; border: solid 1px #e3e3e3; border-radius: 50px; font-weight: 500; align-self: flex-start;">
								{{incident.date | date: 'MM/dd/yyyy'}}
							</span>
						</div>
						<!--incident-->
						<div class="flxRow" style="max-width: 1200px;"
							 *ngIf="incident.type === 'incident'"
							 id="{{incident.created | date: 'MM/dd/yyyy HH:mm'}}">
							<div style="flex-shrink: 0;">
								<span style="font-weight: 500; white-space: nowrap; margin-top: 18px; display: block;">{{incident.created | date: 'HH:mm'}}</span>
							</div>
							<div style="position: relative; padding: 0 2vw;">
								<div style="position: absolute; top: 15px; left: 50%; transform: translateX(-50%); z-index: 50; border-radius: 50px; border: solid 6px; background: hsl(var(--bs-primary-h), 100%, 95%); height: 23px; width: 23px;"
									 [ngStyle]="{'border-color': incident.color}"></div>
								<div [ngStyle]="{'height' : incident.isLastInDate ? '30px' : 'calc(100% - 4px)'}" style="border-left: dotted 4px #e3e3e3;"></div>
							</div>


							<div style="flex: 1 0; padding-bottom: 20px;">
								<div class="flex-column gap-4" style="padding: 15px 25px; box-shadow: 0 3px 5px rgba(0,0,0,0.13); background: white;">
									<!--incident taken actions-->
									<div class="flex-column gap-2">
										<div style="--bs-bg-opacity: 0.065; --bs-border-opacity: 0.5; align-self: flex-start; min-width: 75%;"
											 *ngFor="let action of incident.actions | orderBy: '-created'; trackBy:gs.trackByIndex"
											 class="flex-row align-items-center bg-{{incidentsActionsDic[action.name].color}} border border-{{incidentsActionsDic[action.name].color}} gap-2 p-2 px-3 text-{{incidentsActionsDic[action.name].color}}">
											<i [ngClass]="incidentsActionsDic[action.name].icon"></i>
											<span>
											<span *ngIf="action.name === 'note'" class="fw-500">Note: {{action.action}}</span>
											<span *ngIf="action.name === 'securityReviewerActivity'" class="fw-500">Security Reviewer - {{action.action}}</span>
											<span *ngIf="action.name !== 'note' && action.name !== 'securityReviewerActivity'" class="fw-500">{{incidentsActionsDic[action.name].display}}</span>
												| by: {{action.admin}}. {{action.created | date:'MM/dd/yyyy HH:mm'}}
										</span>
										</div>
									</div>

									<!--incident box-->
									<div class="flxRow-between" style="align-items: center;">
										<!--suspicious_device_change-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'suspicious_device_change'">
											<span *ngIf="!incident.incident_info.new_login"><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> opened an email from a new suspicious device.</span>
											<span *ngIf="incident.incident_info.new_login"><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> logged into their mailbox from a new suspicious device.</span>
											<br/>
											<div class="flxRow hSpace3" *ngIf="!incident.incident_info.new_login">
												<div>
													<b>Client: </b>
													<span *ngIf="incident.incident_info.agent && incident.incident_info.agent.browser">{{incident.incident_info.agent.browser.name + ' (' + incident.incident_info.agent.browser.version + '), ' + incident.incident_info.agent.os.name + ' (' + incident.incident_info.agent.os.version + ')'}}</span>
													<span *ngIf="incident.incident_info.agent && incident.incident_info.agent.raw && !incident.incident_info.agent.browser">{{incident.incident_info.agent.raw.ua || 'N/A'}}</span>
												</div>
												<div>
													<b>Location: </b>
													<span *ngIf="incident.incident_info.location[0]">{{incident.incident_info.location[0].country}}{{incident.incident_info.location[0].city ? (', ' + incident.incident_info.location[0].city) : ''}}</span>
													<img style="cursor: pointer; padding-left: 3px;" *ngIf="incident.incident_info.location[0] && incident.incident_info.location[0].ll" (click)="openLocation(incident.incident_info.location[0].ll)" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
												</div>
											</div>
											<div class="flxRow hSpace3" *ngIf="incident.incident_info.new_login">
												<table class="simpleDataTableShrink" style="table-layout: fixed;">
													<tr>
														<td><b>Operating System:</b></td>
														<td>
															<span>{{incident.incident_info.agent.os.name}}</span>
															<span *ngIf="incident.incident_info.agent.os.version"> ({{incident.incident_info.agent.os.version}})</span>
														</td>
													</tr>

													<tr>
														<td><b>Device Name:</b></td>
														<td><span>{{incident.incident_info.display_name}}</span></td>
													</tr>

													<tr>
														<td><b>Device ID:</b></td>
														<td><span>{{incident.incident_info.device_id}}</span></td>
													</tr>

													<tr *ngIf="incident.incident_info.registrationDateTime">
														<td><b>Login Time:</b></td>
														<td><span>{{incident.incident_info.registrationDateTime | date: 'MM/dd/yyyy HH:mm'}}</span></td>
													</tr>
												</table>
											</div>
										</div>

										<!--suspicious_location_change-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'suspicious_location_change'">
											<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> opened an email from a new suspicious location.</span>
											<br/>
											<label><b>New location detected:</b> {{incident.incident_info.location[0].city && (incident.incident_info.location[0].city + ", ")}}{{incident.incident_info.location[0].country}}
												<img style="cursor: pointer; padding-left: 3px;" *ngIf="incident.incident_info.location[0] && incident.incident_info.location[0].ll" (click)="openLocation(incident.incident_info.location[0].ll)" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
											</label>
											<div>
												<b>IP Address: </b>
												<span>{{incident.incident_info.location[0].ip}}</span>
											</div>
											<div>
												<b>Client: </b>
												<span *ngIf="incident.incident_info.agent && incident.incident_info.agent.browser">{{incident.incident_info.agent.browser.name + ' (' + incident.incident_info.agent.browser.version + '), ' + incident.incident_info.agent.os.name + ' (' + incident.incident_info.agent.os.version + ')'}}</span>
												<span *ngIf="incident.incident_info.agent && !incident.incident_info.agent.browser && incident.incident_info.agent.raw">{{incident.incident_info.agent.raw.ua || 'N/A'}}</span>
											</div>
										</div>

										<!--sending_unusual_amount_of_emails-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'sending_unusual_amount_of_emails'">
											<div *ngIf="incident.incident_info.recentWeekCount" class="flxClmn f-1-0" style="overflow: auto;">
												<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> was sending an unusual amount of emails.</span>
												<br/>
												<table class="simpleDataTableShrink" style="table-layout: fixed; align-self: flex-start;">
													<tr>
														<td><b>Time period:</b></td>
														<td><span>{{incident.incident_info.timeSlot}} GMT</span></td>
													</tr>

													<tr>
														<td><b>Number of emails sent:</b></td>
														<td><span>{{incident.incident_info.recentWeekCount}}</span></td>
													</tr>

													<tr>
														<td><b>Average amount for time period:</b></td>
														<td><span>{{incident.incident_info.avgEmails}}</span></td>
													</tr>
												</table>
											</div>

											<div *ngIf="incident.incident_info.newRecipientsCount" class="flxClmn f-1-0" style="overflow: auto;">
												<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> sent an email to unusual number of recipients.</span>
												<br/>

												<div *ngIf="incident.email_title">
													<b>Email sent: </b>
													<span>{{incident.email_title}}</span>
												</div>

												<div>
													<b>Amount of recipients in this email: </b>
													<span>{{incident.incident_info.newRecipientsCount}}</span>
												</div>

											</div>
										</div>

										<!--sending_burst_emails-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'sending_burst_emails'">
											<div class="flxClmn f-1-0" style="overflow: auto;">
												<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> sent an outbound email burst to multiple domains.</span>
												<br/>
												<table class="simpleDataTableShrink" style="table-layout: fixed; align-self: flex-start;">
													<tr>
														<td><b>Number of recipients:</b></td>
														<td><span>{{incident.incident_info.numRecipients}}</span></td>
													</tr>

													<tr>
														<td><b>Recipient domains:</b></td>
														<td><span>{{incident.incident_info.domains.join(', ')}}</span></td>
													</tr>
												</table>
											</div>
										</div>

										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'abnormal_user_activity'">
											<div class="flxClmn f-1-0" style="overflow: auto;">
												<span>Abnormal activity was observed for user <span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span>.</span>
												<br/>
												{{incident.incident_info?.metric_label}}.
											</div>
										</div>

										<!--outbound_malicious_quarantines-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'outbound_malicious_quarantines'">
											<div class="flxClmn f-1-0" style="overflow: auto;">
												<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> had an outbound email quarantined as malicious.</span>
												<br/>
												<table class="simpleDataTableShrink" style="table-layout: fixed; align-self: flex-start;">
													<tr *ngIf="incident.email_title">
														<td><b>Email subject:</b></td>
														<td><span>{{incident.email_title}}</span></td>
													</tr>
													<tr *ngIf="incident.incident_info.type">
														<td><b>Quarantine type:</b></td>
														<td><span>{{dic.CONSTANTS.quarantinedOutboundType[incident.incident_info.type] || incident.incident_info.type}}</span></td>
													</tr>
												</table>
											</div>
										</div>

										<!--sending_sensitive_to_new_domains-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'sending_sensitive_to_new_domains'">
											<span><span>Sensitive data was sent from <span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> to new domain: <b>{{incident.incident_info.domain}}</b>.</span></span>
											<br/>
											<span *ngIf="incident.incident_info.sensitivity && incident.incident_info.sensitivity.score">
											Sensitivity score:
											<input (click)="openSensitiveInfoPopup(incident)" type="button"
												   value="{{incident.incident_info.sensitivity.score}}"
												   [ngStyle]="incident.incident_info.sensitivity.score < 4 && {'background':'darkorange'} || incident.incident_info.sensitivity.score < 5 && {'background':'#FF851B'} || incident.incident_info.sensitivity.score === 5 && {'background':'#FF4136'}"
												   class="redborder"
												   style="background: orange; height: 25px; width: 25px; margin: 0 auto; color: white !important; border: 0;">
										</span>
										</div>

										<!--sending_sensitive_to_personal_email-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'sending_sensitive_to_personal_email'">
											<span>Sensitive data was sent from <span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span> to free email domain: <b>{{incident.incident_info.domain}}</b>.</span>
											<br/>
											<span *ngIf="incident.incident_info.sensitivity && incident.incident_info.sensitivity.score">
											Sensitivity score:
											<input (click)="openSensitiveInfoPopup(incident)" type="button"
												   value="{{incident.incident_info.sensitivity.score}}"
												   [ngStyle]="incident.incident_info.sensitivity.score < 4 && {'background':'darkorange'} || incident.incident_info.sensitivity.score < 5 && {'background':'#FF851B'} || incident.incident_info.sensitivity.score === 5 && {'background':'#FF4136'}"
												   class="redborder"
												   style="background: orange; height: 25px; width: 25px; margin: 0 auto; color: white !important; border: 0;">
										</span>
										</div>

										<!--email_breach-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'email_breach'">
											<span>Trustifi has detected that a recent data breach contains personal information for <span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span>'s mailbox. </span><br>
											It is highly recommended to change the mailbox password as it may have been leaked in the darknet. <br>
										</div>

										<!--high_recipient_compliant_rate-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'high_recipient_compliant_rate'">
											<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span>'s emails have been reported multiple times as spam or phishing by recipients.</span>
										</div>

										<!--high_recipient_hard_bounce_rate-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'high_recipient_hard_bounce_rate'">
											<span><span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span>'s emails have been bounced on high rate lately. (User is {{incident.incident_info.isUserBlocked ? 'now blocked' : 'not blocked'}})</span>
											<div class="flxClmn vSpace05" *ngIf="incident.incident_info.eventsInfo && incident.incident_info.eventsInfo.length">
												<br/>
												<span style="text-decoration: underline;">Last email bounce:</span>
												<span>Subject: <b>{{incident.incident_info.eventsInfo[0].emailTitle}}</b></span>
												<span>Recipient: <b>{{incident.incident_info.recipient || incident.incident_info.eventsInfo[0].recipient}}</b></span>
											</div>
										</div>

										<!--new_forward_redirect_rules-->
										<div class="flxClmn vSpace05" *ngIf="incident.incident_type === 'new_forward_redirect_rules'">
											<span>A suspicious mailbox rule has been found for mailbox <span (click)="getUserAccountInfo(incident.user_email)" style="font-weight: bold; cursor: pointer; color: royalblue;">{{incident.user_name}}</span>.</span>
											<div class="flxClmn vSpace05">
												<br/>
												<span style="text-decoration: underline;">Rule information:</span>
												<span>Name:
													<ng-container *ngIf="accountCompromisedService.getSuspiciousMailboxRuleDisplayName(incident.incident_info) as ruleName; else noMailboxRuleName">
														<b>{{ruleName}}</b>
													</ng-container>
													<ng-template #noMailboxRuleName><i style="color: var(--bs-secondary); font-style: italic;">No rule name</i></ng-template>
												</span>
												<span *ngIf="incident.incident_info.actionSummary">Conditions: <b>Apply to all messages</b></span>
												<span *ngIf="incident.incident_info.actionSummary">Actions: <b>{{incident.incident_info.actionSummary}}</b></span>
												<span *ngIf="incident.incident_info.redirect || incident.incident_info.forward">{{incident.incident_info.redirect ? 'Redirect' : 'Forward'}} to: <b>{{incident.incident_info.redirect || incident.incident_info.forward}}</b><ng-container *ngIf="!incident.incident_info.actionSummary && incident.incident_info.recipient_free_email_domain"> (free email domain)</ng-container></span>
											</div>
										</div>

										<div class="flxClmn gap-1">
											<app-dropdown-c style="width: 180px; --bs-dropdown-max-height: 200px; --bs-dropdown-overflow: auto;"
															[style.--bs-dropdown-menu-max-height]="(36 * incidentActionsTimeline.length) + 'px'";
															[items]="incidentActionsTimeline"
															text="Actions"
															itemDisplayKey="display"
															(onItemClicked)="selectAction(incident, $event.item.display)">
											</app-dropdown-c>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</virtual-scroller>

				<div class="d-flex centralize f-1-0" *ngIf="!flatIncidentsByDate || !flatIncidentsByDate.length">
					<span>No incidents in list</span>
				</div>
			</div>

			<div class="flex-column animated fadeIn p-4 gap-3" style="flex: 1 0; margin: clamp(5px, 2vw, 25px); box-shadow: 0 0 6px lightgrey; background: white; position: sticky; top: clamp(5px, 2vw, 25px);"
				 *ngIf="!loadingIncidentsInProcess">
				<div class="flex-row justify-content-between">
					<h6>User Statuses</h6>
					<search-box [(model)]="searchUserStatusTxt"
								(modelChange)="searchUserStatus()"
								[isDisabled]="!usersStatuses?.length"
								style="min-width: 160px;">
					</search-box>
				</div>

				<div class="flex-column f-1-0 overflow-auto thinner-scrollbar">
					<table class="simpleDataTable w-100" style="table-layout: fixed;">
						<tr style="position: sticky; top: 0; background: white; z-index: 50;">
							<th>
								User
								<a class="area" style="margin-top:1px; padding-left:5px;" title="Sort"
								   (click)="sortUser = sortUser === 'created' ? '-created' : 'created'; orderUsersStatusesBy = sortUser;">
									<i class="zmdi zmdi-chevron-down" [ngStyle]="{'transform' : sortUser === 'created' ? 'rotate(180deg)' : ''}"></i>
								</a>
							</th>
							<th style="width: 130px;">
								Status
								<a class="area" style="margin-top:1px; padding-left:5px;" title="Sort"
								   (click)="sortStatus = sortStatus === 'status' ? '-status' : 'status'; orderUsersStatusesBy = sortStatus;">
									<i class="zmdi zmdi-chevron-down" [ngStyle]="{'transform' : sortStatus === 'status' ? 'rotate(180deg)' : ''}"></i>
								</a>
							</th>
						</tr>
						<tr *ngFor="let userStatusObj of usersStatuses | filter: {hide : '!true'} | orderBy: orderUsersStatusesBy; trackBy:gs.trackByIndex">
							<td class="ellipsis" title="{{userStatusObj.email}}">{{userStatusObj.email}}</td>
							<td style="line-height: 1.4;">
								<span style="color: darkred;">{{userStatusObj.status}}</span>
								<br/>
								<span class="text-muted" style="font-size: 11px;">{{userStatusObj.created | date: 'MM/dd/yyyy HH:mm' }}</span>
							</td>
						</tr>
					</table>
					<div class="f-1-0 d-flex centralize" *ngIf="!_.reject(usersStatuses, 'hide').length">
						<span *ngIf="searchUserStatusTxt">No results found for this search</span>
						<span *ngIf="!searchUserStatusTxt">No users statuses to display</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<user-incidents-info-component></user-incidents-info-component>

	<sensitivity-details
			*ngIf="sensitiveInfoPopup?.show"
			type="email"
			(cancelCb)="sensitiveInfoPopup = null;"
			[scanTitle]="sensitiveInfoPopup.emailTitle"
			[sensitivity]="sensitiveInfoPopup.sensitivity">
	</sensitivity-details>

	<!--show account info popup-->
	<account-user-info  *ngIf="showAccountInfoPopup"
		[showAccountInfoPopup]="showAccountInfoPopup"
		[mailboxEmail]="accountInfo.email"
		(close)="showAccountInfoPopup = false">
	</account-user-info>

</div>


